import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    usageEventType : [],
    loading : false,
    error : null,
};

const usageEventTypeSlice = createSlice({
    name:"usageEventType",
    initialState,
    reducers: {
        fetchUsageEventTypeSuccess: (state,action) => {
            state.loading = false;
            state.usageEventType = action.payload;
        },
        fetchUsageEventTypeFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchUsageEventTypeSuccess,
    fetchUsageEventTypeFailure
} = usageEventTypeSlice.actions

export default usageEventTypeSlice.reducer